export class Constants {
    static IDO2C = 49;
    static IDPREBOOKS = 50;
    static IDOPERATIONS = 61;
    static IDACCOUNTING = 300;
    static MAX_DATE_RANGE = 30;
    static MAX_INVOICE_NUMBER = 99999999;
    static MAX_PO_NUMBER = 30;
    static MAX_ORDER_NUMBER = 15;
	static MAX_LENGTH_NAME = 30;
	static MAX_LENGTH_COUNTRY = 6;
    static MAX_LENGTH_DESCRIPTION = 100;
    static MAX_LENGTH_DESCRIPTION_COMPLAINT = 1000;
    static MAX_LENGTH_CONFIRMATION_NOTE_COMPLAINT = 1000;
    static MIN_LENGTH_DESCRIPTION_COMPLAINT = 50;
    static MIN_LENGTH_PALLET_ID_COMPLAINT = 11;
    static MAX_LENGTH_PALLET_ID_COMPLAINT = 20;
    static MAX_LENGTH_URL = 70;
    static MAX_LENGTH_VIEW_PORTAL = 1;
    static MAX_LENGTH_PERCENTAGE = 3;
    static MAX_LENGTH_CODE = 50;
    static MAX_LENGTH_TYPE = 25;
    static MAX_LENGTH_DIS_CODE = 6;
    static MAX_LENGTH_COLOR = 20;
    static EMAIL_PATTERN = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    static LOT_NUMBER_LENGTH = 7;
    static PO_ORDERS_SPLIT = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    static PO_ORDERS_SPECIAL_INSTRUCTIONS = 50;
	static MAX_SO_NUMBER_LENGTH = 50;
	static TIME_IN_MINS = 480;
    static MAX_COMPLAINT_NUMBER = 9;

    // Password rules
    static atLeastCharacters = 8;
    static containsLetter = false;
    static containsLowerCase = true;
    static containsUpperCase = true;
    static containsNumber = true;
    static containsSpecial = true;
    static specialsCharacters = '!@#$%^&*?()_+';
}
